<template>
  <div class="bottom">
    <div class="four">
      <div class="four-box">
        <dl v-for="(item, index) in list" :key="index">
          <h3>{{ item.title }}</h3>
          <a
            href="javascript:;"
            v-for="(i, v) in item.connect"
            :key="v"
            :class="i.id === currentIndex ? 'active' : ''"
            @mouseenter="mouseOver(i.id)"
            @mouseleave="mouseLeave(i.id)"
            @click="goUrl(i.url ,i.type ? i.type :'',v,i.urls)"
          >
            {{ i.title }}
          </a>
        </dl>
        <div><img src="../images/1.jpg" alt="" /></div>
      </div>
    </div>
    <div class="five">
      <span style="color: #A52A2A;">
        本网站销售的所有产品仅用于工业应用或者科学研究等非医疗目的，不可用于人类或动物的临床诊断或治疗，非药用，非食用。</span><br />
         <span> 沪(浦)应急管危经许[2021]204828(QYS)</span><br />
        <span ><span style="cursor: pointer;" @click="goanbei()">沪公网安备31011502016647号</span> <span  style="margin-left:16px;cursor: pointer;" @click="gobei()">沪ICP备 2020029099号-1</span>   </span>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      currentIndex: "",
      list: [
          {
          title: "关于我们",
          connect: [
            { title: "走进百生跃", id: 1, url: "/aboutUs/companyProfile" },
            { title: "诚聘英才", id: 12, url: "/aboutUs/talentedPeople" },
            { title: "代理招商", id: 13, url: "/aboutUs/agentInvestment" },
            { title: "新闻中心", id: 2, url:"/workIn" },
          ],
        },
        {
          title: "技术支持",
          connect: [
            {
              title: "学习中心",
              id: 3,
              url: "/technicalSupports/learningCenter",
            },
            // { title: "说明书下载", id: 4, url: "/technicalSupports/Download" },
            // { title: "MSDS查询", id: 5, url: "/technicalSupports/Inquire" },
            { title: "COA查询", id: 6, url: "/technicalSupports/coaInquire" },
          ],
        },
        {
          title: "客户服务",
          connect: [
            {title: "付款方式", id: 7, url: '/html', type: 'fukuan'},
            {title: "配送说明", id: 8, url: '/html', type: 'peisong'},
            {title: "发票说明", id: 9, url: '/html', type: 'fapiao'},
            {title: "运费说明", id: 10, url: '/html', type: 'freight'},
            {title: "退换政策", id: 11, url: '/html', type: 'tuihuan'},
            {title: "科研工具", id: 'calculator', url: '/calculator', type: ''}
          ],
        },
        {
          title: "快速链接",
          connect: [
            { title: "走进麦克林", id: 14, urls: "http://www.macklin.cn/" },
          ],
        },
      ],
    };
  },
  methods: {
    goUrl(url,type,index,urls) {
      if (url == this.$route.path) {
        this.$router.push({path:url,query:{type:type,index:index}})
        this.$router.go(0)
      }else if(urls){
         window.open(urls, '_blank')
      }else{
         this.$router.push({path:url,query:{type:type,index:index}})
      }
    },
    mouseOver(index) {
      this.currentIndex = index;
    },
    mouseLeave(index) {
      this.currentIndex = "";
    },
    gobei(){
      let url = 'https://beian.miit.gov.cn'
      window.open(url,'_blanck')
    },
    goanbei(){
      let url = 'https://www.beian.gov.cn/portal/registerSystemInfo?recordcode=31011502016647'
      window.open(url,'_blanck')
    }
  },
};
</script>

<style lang="less" scoped>
*{
  font-size: 16px;;
}
.four {
  width: 1510px;
  min-height: 316px;
  margin: 17px auto;
  background: url("../images/four.png") no-repeat;
  background-position: center;
  background-size: contain;
  .four-box {
    width: 1194px;
    margin: auto;
    height: 100%;
    display: flex;
    dl {
      width: 111px;
      margin-top: 54px;
      margin-right: 150px;
      h3 {
        font-size: 20px;
        font-weight: 700;
        text-align: left;
        color: #333333;
        margin-bottom: 28px;
      }
      a {
        font-size: 16px;
        text-align: left;
        color: #666666;
        line-height: 32px;
        display: block;
      }
      .active {
        color: #A52A2A;
      }
    }
    div {
      margin-top: 60px;
      img {
        width: 118px;
        height: 115px;
      }
    }
  }
}
.five {
  min-height: 49px;
  text-align: center;
  margin-top: 13px;
  font-weight: 700;
  margin: auto;
  span {
    font-size: 14px;
    line-height: 24px;
    font-weight: 700;
  }
}
</style>
